// extracted by mini-css-extract-plugin
module.exports =  {"btn-spacer":"_93444fe79c--btn-spacer--wRzGk"};